<template>
  <modal :modal-key="'confirm_purchase'" :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
    <template slot="header">
           <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
          <img class="usericon" src="static/images/happy_face_2.svg" alt="">
    </template>
        <template slot="body">
          <p class="modal_strong" v-if="!getBundleData.joker">
            {{ getBundleData.numberOfGames?getBundleData.numberOfGames + ' ' + getTranslations.home_modals_confirm_purchase_games:'' }}
              {{getBundleData.numberOfGames && getBundleData.points ?getTranslations.home_modals_confirm_purchase_and:'' }}
             {{ getBundleData.points?getBundleData.points + ' ' + getTranslations.home_modals_confirm_purchase_points:''}}
            – {{ getBundleData.price
            }} {{ getBundleData.currencyCode }}</p>
          <p class="modal_strong"  v-else>
            {{ getBundleData.numOfJokers }} {{ getTranslations.home_modals_confirm_purchase_jokers }} – {{ getBundleData.price
            }} {{ getBundleData.currencyCode }}</p>
          <p v-if="getBundleData.joker">{{ getTranslations.home_modals_confirm_purchase_jokers_increase }}</p>
          <p v-if="getBundleData.joker"> {{ getTranslations.home_modals_confirm_purchase_please_confirm }}</p>
          <p v-if="!getBundleData.joker">{{ getTranslations.home_modals_confirm_purchase_playing_more }}</p>
          <p v-if="!getBundleData.joker">{{ getTranslations.home_modals_confirm_purchase_are_you_sure_you_want_to_continue }}</p>
        </template>
        <template slot="footer">
          <button :class="['btn2 btn2--std btn2--small btn2--fixed',(!buttonEnabled) ? 'deactivated' : '']"
                  @click.prevent="purchaseBundle()">{{ getTranslations.home_modals_confirm_purchase_purchase_now_button
            }}
          </button>
        </template>
  </modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import FailedPurchase from './FailedPurchase';
import ConfirmPurchaseSuccessful from './ConfirmPurchaseSuccessful';
import FailedPurchaseOperator from './FailedPurchaseOperator';

export default {
  name: 'confirmPurchase',
  components: {
    Modal,
  },
  data() {
    return {
      buttonEnabled: true,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'chargePinCall',
    ]),
    purchaseBundle() {
      this.buttonEnabled = false;
      this.getUserLoginDetails().then(() => {
        const bundleInfo = {
          bundleId: this.bundleId,
          pin: null,
        };
        this.chargePinCall({ value: bundleInfo }).then(() => {
          this.buttonEnabled = true;
          if (this.chargePinResponse === 'OPERATION_SUCCESS') {
            this.$emit('bundlePurchase');
            this.storeModalForStore(ConfirmPurchaseSuccessful);
          } else if (this.chargePinResponse === 'BILLING_FAILED') {
            this.storeModalForStore(FailedPurchaseOperator);
          } else if (this.chargePinResponse === 'NO_BALANCE') {
            this.storeModalForStore(FailedPurchase);
          } else {
            this.storeModalForStore(FailedPurchaseOperator);
          }
        });
      });
    },
  },
  computed: {
    ...mapState('profile', [
      'chargePinResponse',
      'bundleId',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchase.vue